import React, { useState, useEffect, useContext, useCallback } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  Typography,
  Grid,
  Divider,
  TableContainer,
  // Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  List,
  ListItem,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import Linechartapi from "../../Item/linechartapi";
import Piechartapi from "../../Item/piechartapi";
import { FaCircle } from "react-icons/fa";
import Barchartperm from "../../Item/Barchartperm";
import { LangContext } from "../../../Context/Langcontext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  // pdf,
  Page,
  // Text,
  View,
  Document,
  // StyleSheet,
  // PDFDownloadLink,
  // BlobProvider,
} from "@react-pdf/renderer";
import { useSnackbar } from "notistack";
import { ServiceContext } from "../../../Context/ServiceContext";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    minHeight: "-webkit-fill-available",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    // maxHeight: "100%",
    // minHeight: "100%",
    minHeight: "-webkit-fill-available",
    maxHeight: "100%",
  },

  cardreport: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",

    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 24.2rem)",
    },
    [theme.breakpoints.up("md")]: {
      height: "calc(100vh - 17.9rem)",
    },
  },
  texthead: {
    color: "#595A5A",
    fontWeight: 700,
  },
  usetext: {
    // fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 700,
  },
  maintext: {
    // fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  titletext: {
    marginRight: "1rem",
    color: "#E16733",
    fontWeight: 400,
  },
  nametext: {
    color: "#595A5A",
    fontWeight: 200,
  },
  tablecell: {
    color: "#595A5A",
    fontWeight: 200,
  },
  textsum: {
    fontWeight: 400,
    color: "#595A5A",
    fontSize: "1.2rem",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  secondtext: {
    fontWeight: 200,
    color: "#595A5A",
  },
  gridend: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "1rem",
  },
  gridres: {
    [theme.breakpoints.down("sm")]: {
      margin: "2rem",
    },
    [theme.breakpoints.up("md")]: {
      margin: "4rem",
    },
  },
  export: {
    textTransform: "unset",
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  a4size: {
    width: "210mm",
    minHeight: "297mm",
    marginLeft: "auto",
    marginRight: "auto",
  },
  sizedefault: {
    // textAlign: "center",
    // width: "100%",
    padding: theme.spacing(2),
  },
  exporticon: {
    width: "2rem",
    height: "auto",
    transition: "transform .2s",
    "&:hover": {
      transform: "scale(1.5)",
    },
  },
  // react-pdf
  pdfPage: {
    // backgroundColor: "#E4E4E4"
  },
}));

const Reportadmin = ({ state, loading, setloading, sum }) => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const classes = useStyle();
  const [size, setsize] = useState(true);
  const serviceContext = useContext(ServiceContext);
  const { enqueueSnackbar } = useSnackbar();

  var monthNames = [
    lang.January,
    lang.February,
    lang.March,
    lang.April,
    lang.May,
    lang.June,
    lang.July,
    lang.August,
    lang.September,
    lang.October,
    lang.November,
    lang.December,
  ];

  const [detail, setdetail] = useState(undefined);

  const colors = ["#F1B351", "#ADCAC8"];

  const getData = useCallback(() => {
    setdetail([
      { title: lang.User, name: state.name !== null ? state.name.title : "-" },
      {
        title: "Key name",
        name: state.key === "other" ? "ทั้งหมด" : state.key,
      },
      {
        title: lang.Month,
        name:
          state.month === "allmonth"
            ? lang.Allmonth
            : monthNames[Number(state.month) - 1],
      },
      { title: lang.Year, name: state.year },
    ]);
  }, [detail, state, monthNames, lang]);

  useEffect(() => {
    if (state.filter && !detail) {
      getData();
    } else if (!state.filter && detail) {
      console.log("clear reportadmin");
      setdetail(undefined);
    }
  }, [state, getData]);

  const genPDF = async () => {
    const doc = new jsPDF("p", "mm");
    const position = 10;
    const imgWidth = 190;

    const input1 = document.getElementById("pdf-page-1");
    const canvas1 = await html2canvas(input1);
    const imgData1 = canvas1.toDataURL("image/png");
    const imgHeight1 = Number(canvas1.height * imgWidth) / canvas1.width;

    const input2 = document.getElementById("pdf-page-2");
    const canvas2 = await html2canvas(input2);
    const imgData2 = canvas2.toDataURL("image/png");
    const imgHeight2 = Number(canvas2.height * imgWidth) / canvas2.width;

    // var pageHeight = 295;

    console.log(imgHeight1);
    // var heightLeft = imgHeight;
    doc.addImage(imgData1, "JPEG", position, position, imgWidth, imgHeight1);
    doc.addPage();
    doc.addImage(imgData2, "JPEG", position, position, imgWidth, imgHeight2);
    // heightLeft -= pageHeight;
    if (state.month === "allmonth") {
      const input3 = document.getElementById("pdf-page-3");
      const canvas3 = await html2canvas(input3);
      const imgData3 = canvas3.toDataURL("image/png");
      const imgHeight3 = Number(canvas3.height * imgWidth) / canvas3.width;
      doc.addPage();
      doc.addImage(imgData3, "JPEG", position, position, imgWidth, imgHeight3);
    }
    // while (heightLeft >= 0) {
    //   position = heightLeft - imgHeight;
    //   doc.addPage();
    //   doc.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight + 15);
    //   heightLeft -= pageHeight;
    // }
    doc.save("Dashboard.pdf");

    setsize(false);
  };

  const convertDate = (date) => {
    let dateObj = new Date(date);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, "0");
    return state.month === "allmonth" ? `${month}` : `${day} ${month}`;
  };

  const rename = (s_id) => {
    const name = serviceContext.data.find((rs) => {
      return rs._id === s_id;
    });
    if (name) {
      return name.name;
    } else {
      return null;
    }
  };

  const reData = (e) => {
    let output = [];
    e.sort((a, b) =>
      a._id.datetime_ref > b._id.datetime_ref ? 1 : -1
    ).forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.name === convertDate(item._id.datetime_ref);
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(convertDate(item._id.datetime_ref));

        output[existingIndex][item._id.service_id] = Number(
          Number(
            output[existingIndex][item._id.service_id]
              ? output[existingIndex][item._id.service_id]
              : 0
          ) + Number(item.sum_request)
        );
      } else {
        if (typeof convertDate(item._id.datetime_ref) === "string") {
          let input = {};
          input.name = convertDate(item._id.datetime_ref);
          input[item._id.service_id] = item.sum_request;
          output.push(input);
        }
      }
    });
    return output;
  };

  const mergData = reData(sum);

  const findInAPI = (id) => {
    let dataapi = serviceContext.data.find((rs) => {
      return rs._id === id;
    });
    return dataapi;
  };
  const dataPie = (e) => {
    let output = [
      { name: lang.MapService, value: 0 },
      { name: lang.DataService, value: 0 },
      { name: lang.Premium, value: 0 },
    ];
    e.forEach(function (item) {
      console.log(findInAPI(item._id.service_id).category === "premium");
      var existing = output.filter(function (v, i) {
        return (v.name === findInAPI(item._id.service_id).category) === "data"
          ? lang.DataService
          : (v.name === findInAPI(item._id.service_id).category) === "premium"
          ? lang.Premium
          : lang.MapService;
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(
            findInAPI(item._id.service_id).category === "data"
              ? lang.DataService
              : findInAPI(item._id.service_id).category === "premium"
              ? lang.Premium
              : lang.MapService
          );

        output[existingIndex]["value"] = Number(
          Number(
            output[existingIndex]["value"] ? output[existingIndex]["value"] : 0
          ) + Number(item.sum_request)
        );
      } else {
        if (typeof findInAPI(item._id.service_id).category === "string") {
          let input = {};
          input.name =
            findInAPI(item._id.service_id).category === "data"
              ? lang.DataService
              : findInAPI(item._id.service_id).category === "premium"
              ? lang.Premium
              : lang.MapService;
          input.value = item.sum_request;
          output.push(input);
        }
      }
    });
    return output;
  };

  const piedata = dataPie(sum);

  function createRow(layer, request) {
    return { layer, request };
  }

  const dataRows = (e) => {
    let output = [];
    e.forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.name === rename(item._id.service_id);
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(rename(item._id.service_id));

        output[existingIndex]["value"] = Number(
          Number(
            output[existingIndex]["value"] ? output[existingIndex]["value"] : 0
          ) + Number(item.sum_request)
        );
      } else {
        if (typeof findInAPI(item._id.service_id).category === "string") {
          let input = {};
          input.name = rename(item._id.service_id);
          input.value = item.sum_request;
          output.push(input);
        }
      }
    });
    return output;
  };

  const rows = dataRows(sum).map((rs) => {
    return createRow(rs.name, rs.value);
  });

  const getAll = () => {
    let count = 0;
    for (var i = 0; i < rows.length; i++) {
      count = count + rows[i].request;
    }
    return count;
  };

  const dataAllMonth = (e) => {
    let output = [];
    e.sort((a, b) =>
      a._id.datetime_ref > b._id.datetime_ref ? 1 : -1
    ).forEach(function (item) {
      var existing = output.filter(function (v, i) {
        return v.name === convertDate(item._id.datetime_ref);
      });

      if (existing.length) {
        var existingIndex = output
          .map((rs) => {
            return rs.name;
          })
          .indexOf(convertDate(item._id.datetime_ref));

        output[existingIndex]["usage"] = Number(
          Number(
            output[existingIndex]["usage"] ? output[existingIndex]["usage"] : 0
          ) + Number(item.sum_request)
        );
      } else {
        if (typeof convertDate(item._id.datetime_ref) === "string") {
          let input = {};
          input.name = convertDate(item._id.datetime_ref);
          input["usage"] = item.sum_request;
          output.push(input);
        }
      }
    });
    return output;
  };

  const PdfDoc = () => (
    <Document className={classes.pdfPage}>
      <Page size="A4">
        <View>
          <Typography className={classes.maintext}>
            {state.month === "allmonth"
              ? "รายงานสรุปการใช้งานประจำปี"
              : "รายงานสรุปการใช้งานประจำเดือน"}
          </Typography>
          <Grid container style={{ marginBottom: "16px" }}>
            {detail.map((res) => {
              return (
                <Grid
                  item
                  xs={6}
                  key={res.title}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Typography className={classes.titletext}>
                      {`${res.title} :`}
                    </Typography>
                    <Typography className={classes.nametext}>
                      {res.name}
                    </Typography>
                  </div>
                </Grid>
              );
            })}
          </Grid>
          <Divider />
          <Grid container>
            <Grid
              item
              md={5}
              sm={12}
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Piechartapi data={piedata} />
            </Grid>
            <Grid
              item
              md={7}
              sm={12}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <Typography className={classes.usetext}>
                การใช้งานประเภท API
              </Typography>
              <List>
                {piedata.map((res, index) => {
                  return (
                    <ListItem key={res.name} style={{ padding: "unset" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FaCircle
                          style={{
                            color: colors[index],
                            marginRight: "1rem",
                          }}
                        />
                        <Typography
                          className={classes.nametext}
                          style={{
                            marginRight: "2rem",
                          }}
                        >
                          {res.name}
                        </Typography>
                        <Typography
                          className={classes.nametext}
                          style={{
                            marginRight: "2rem",
                          }}
                        >
                          {res.value}
                        </Typography>
                        <Typography className={classes.nametext}>
                          {lang.Request.toLowerCase()}
                        </Typography>
                      </div>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </View>
      </Page>
    </Document>
  );

  return (
    <div className={classes.root}>
      {state.loading ? (
        <Card className={classes.cardreport}>
          <CircularProgress />
        </Card>
      ) : (
        <>
          {state.filter && detail ? (
            // <Card
            //   style={{
            //     marginTop: "0.5rem",
            //     marginBottom: "0.1rem",
            //   }}
            // >
            //   <div className={classes.sizedefault}>
            //     {PdfDoc()}
            //     <Grid container>
            //       <Grid item xs={12} className={classes.gridend}>
            //         <Tooltip title="คลิกเพื่อนำออก PDF" placement="top">
            //           <Button
            //             startIcon={
            //               <img
            //                 alt="export_pdf"
            //                 src={require("../../../images/graphic-icon/export_pdf.png")}
            //                 className={classes.exporticon}
            //               />
            //             }
            //             className={classes.export}
            //             onClick={async () => {
            //               setsize(true);
            //               enqueueSnackbar("Exporting pdf ... ", {
            //                 variant: "success",
            //               });
            //               try {
            //                 const blob = await pdf(PdfDoc);
            //                 console.log(blob);
            //               } catch (error) {
            //                 console.log(error);
            //               }
            //               // setTimeout(() => {
            //               //   genPDF();
            //               // }, 5000);
            //             }}
            //           >
            //             {`${lang.Export} PDF`}
            //           </Button>
            //         </Tooltip>
            //       </Grid>
            //     </Grid>
            //   </div>
            // </Card>
            <Card className={classes.cardapi}>
              <div
                className={
                  classes.a4size
                  //size ? classes.a4size : classes.sizedefault
                }
              >
                <div className={classes.gridres}>
                  <div id="pdf-page-1">
                    <Typography className={classes.maintext}>
                      {state.month === "allmonth"
                        ? "รายงานสรุปการใช้งานประจำปี"
                        : "รายงานสรุปการใช้งานประจำเดือน"}
                    </Typography>
                    <Grid container style={{ marginBottom: "16px" }}>
                      {detail.map((res) => {
                        return (
                          <Grid
                            item
                            xs={6}
                            key={res.title}
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Typography className={classes.titletext}>
                                {`${res.title} :`}
                              </Typography>
                              <Typography className={classes.nametext}>
                                {res.name}
                              </Typography>
                            </div>
                          </Grid>
                        );
                      })}
                    </Grid>
                    <Divider />
                    <Grid container>
                      <Grid
                        item
                        md={5}
                        sm={12}
                        xs={12}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Piechartapi data={piedata} />
                      </Grid>
                      <Grid
                        item
                        md={7}
                        sm={12}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                        }}
                      >
                        <Typography className={classes.usetext}>
                          การใช้งานประเภท API
                        </Typography>
                        <List>
                          {piedata.map((res, index) => {
                            return (
                              <ListItem
                                key={res.name}
                                style={{ padding: "unset" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <FaCircle
                                    style={{
                                      color: colors[index],
                                      marginRight: "1rem",
                                    }}
                                  />
                                  <Typography
                                    className={classes.nametext}
                                    style={{
                                      marginRight: "2rem",
                                    }}
                                  >
                                    {res.name}
                                  </Typography>
                                  <Typography
                                    className={classes.nametext}
                                    style={{
                                      marginRight: "2rem",
                                    }}
                                  >
                                    {res.value}
                                  </Typography>
                                  <Typography className={classes.nametext}>
                                    {lang.Request.toLowerCase()}
                                  </Typography>
                                </div>
                              </ListItem>
                            );
                          })}
                        </List>
                      </Grid>
                      <Grid item sm={12} md={12} xs={12}>
                        <Typography
                          style={{
                            fontWeight: 700,
                            // fontSize: "1.2rem",
                            color: "#595A5A",
                            textAlign: "left",
                          }}
                        >
                          {lang.APIUsage}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ width: "100%" }}>
                        <Linechartapi
                          type="all"
                          size={size}
                          data={mergData}
                          sum={sum}
                          loading={loading}
                          setloading={setloading}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <Grid container id="pdf-page-2">
                    <Grid item xs={12}>
                      <TableContainer
                        style={{
                          boxShadow: "unset",
                          border: "2px solid #F0F0EA",
                        }}
                        // component={Paper}
                        id="pdf2"
                      >
                        <Table aria-label="spanning table" size="small">
                          <TableHead style={{ backgroundColor: "#f9f9f9" }}>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.texthead}
                                // style={{
                                //   borderRight: "1px solid #e3e3e3",
                                //   width: "50%",
                                // }}
                              >
                                {lang.Layer}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.texthead}
                                // style={{ width: "50%" }}
                              >
                                {langContext.lang.locale === "th"
                                  ? "การร้องขอ (จำนวนครั้ง)"
                                  : "Requests"}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map((row, index) => (
                              <TableRow
                                key={row.layer}
                                style={{
                                  backgroundColor:
                                    index % 2 === 1 ? "#f9f9f9" : "#FFFFFF",
                                }}
                              >
                                <TableCell
                                  align="left"
                                  className={classes.tablecell}
                                  // style={{ borderRight: "1px solid #e3e3e3" }}
                                >
                                  {row.layer}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  // className={classes.tablecell}
                                >
                                  {row.request.toLocaleString()}
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow
                              style={{
                                backgroundColor: "#f9e1d7",
                              }}
                            >
                              <TableCell
                                align="center"
                                className={classes.texthead}
                                style={{ fontWeight: "bold" }}
                              >
                                {lang.Total}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.texthead}
                                style={{ fontWeight: "bold" }}
                              >
                                {getAll().toLocaleString()}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>

                  {state.month === "allmonth" ? (
                    <Grid container id="pdf-page-3">
                      <Barchartperm
                        genPDF={genPDF}
                        setsize={setsize}
                        data={dataAllMonth(sum)}
                      />
                    </Grid>
                  ) : null}

                  <Grid container>
                    <Grid item xs={12} className={classes.gridend}>
                      {state.month === "allmonth" ? null : (
                        <Tooltip title="คลิกเพื่อนำออก PDF" placement="top">
                          <Button
                            startIcon={
                              <img
                                alt="export_pdf"
                                src={require("../../../images/graphic-icon/export_pdf.png")}
                                className={classes.exporticon}
                              />
                            }
                            className={classes.export}
                            onClick={() => {
                              setsize(true);
                              enqueueSnackbar("Exporting pdf ... ", {
                                variant: "success",
                              });
                              setTimeout(() => {
                                genPDF();
                              }, 5000);
                            }}
                          >
                            {`${lang.Export} PDF`}
                          </Button>
                        </Tooltip>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Card>
          ) : (
            <Card className={classes.cardreport}>
              <div
                id="pdf-page-3"
                style={{
                  textAlign: "center",
                }}
              >
                <img
                  alt="report"
                  src={require("../../../images/graphic-icon/report.png")}
                  style={{ height: "8rem", width: "auto" }}
                />

                <Typography className={classes.textsum}>
                  {lang.Individual}
                </Typography>
                <Typography className={classes.secondtext}>
                  {lang.Seachforname}
                </Typography>
              </div>
            </Card>
          )}
        </>
      )}
    </div>
  );
};

export default Reportadmin;
